import { toSnakeCase } from 'wanderu-utils';

import StructuredEvent from './StructuredEvent';

class PixelStructuredEvent extends StructuredEvent {
    format() {
        return {
            e: 'se',
            aid: 'ui_react',
            tna: 'pixel',
            se_ca: toSnakeCase(this.category),
            se_ac: toSnakeCase(this.action),
            se_la: toSnakeCase(this.label),
            se_pr: this.normalizeNonStringObjects(this.property),
            se_va: this.value,
        };
    }
}

export default PixelStructuredEvent;
